import { toStringFqn } from 'app/lib/utils';
import type { DeploymentOverviewEntry } from 'app/lib/types/server';

export interface TransformedDeploymentOverviewEntry extends DeploymentOverviewEntry {
    snowflakeFQN: string;
    projectAndDataset?: string;
    projectOrDatasetDeleted?: boolean;
}
export function transformOverviewEntries(
    entries: DeploymentOverviewEntry[]
): TransformedDeploymentOverviewEntry[] {
    if (entries.length === 0) {
        return [];
    }

    return entries.map((entry) => {
        const { projectName, projectSlug, projectDatasetName, projectDatasetSlug, ...rest } = entry;
        const snowflakeFQN = toStringFqn(entry);

        if (!projectSlug || !projectDatasetSlug) {
            return {
                ...rest,
                projectOrDatasetDeleted: true,
                snowflakeFQN
            };
        }

        return {
            ...entry,
            snowflakeFQN,
            projectAndDataset: `${projectName}.${projectDatasetName}`
        };
    });
}
